import { render, staticRenderFns } from "./VehicleCost.vue?vue&type=template&id=341596ff&scoped=true&"
import script from "./VehicleCost.vue?vue&type=script&lang=js&"
export * from "./VehicleCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341596ff",
  null
  
)

export default component.exports